import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	logo: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.icon-upload.logo',
		defaultMessage: 'Logo',
		description: 'Title of logo uploader section',
	},
	title: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.icon-upload.title',
		defaultMessage: 'Upload an icon',
		description: 'Title of icon uploader',
	},
	upload: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.icon-upload.upload',
		defaultMessage: 'Upload',
		description: 'Upload image button',
	},
	uploadButtonChange: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.icon-upload.upload-button-change',
		defaultMessage: 'Change logo',
		description: 'Button text to open upload prompt when a logo is being used currently',
	},
	uploadButtonAdd: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.icon-upload.upload-button-add',
		defaultMessage: 'Add logo',
		description: 'Button text to open upload prompt when no logo is being used currently',
	},
	deleteButton: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.icon-upload.delete-button',
		defaultMessage: 'Delete current logo',
		description: 'Button text to delete custom image',
	},
	portalLogoAlt: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.icon-upload.portal-logo-alt',
		defaultMessage: 'Portal logo image',
		description: 'Alt text to describe the portal logo image',
	},
});
